<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">上报管理</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="上报时间" prop="ReportTime">
            <el-date-picker
              v-model="ReportTime"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="上报点位">
            <el-select v-model="ReportStationId" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in ReportStationArr"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
            <el-button @click="isSendMsgDialogVisible=true">生 成 日 报</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="ReportStartTime" label="起始时间"  :formatter="formatDateTime"></el-table-column>
              <el-table-column prop="ReportEndTime" label="截止时间"  :formatter="formatDateTime"></el-table-column>
              <el-table-column prop="ReportTime" label="上报时间"  :formatter="formatDateTime"></el-table-column>
              <el-table-column prop="ReportStationName" label="上报点位"></el-table-column>
              <el-table-column prop="ReportNumber" label="接待人次"></el-table-column>
              <el-table-column prop="ReportMoney" label="上报收入"></el-table-column>
              <el-table-column prop="Creater" label="上报人员"></el-table-column>
              <el-table-column prop="ReportSource" label="数据来源"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >查看</el-button>
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >编辑</el-button>
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >删除</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
     <el-dialog destroy-on-close="true" top="30vh" :visible.sync="isSendMsgDialogVisible" title="发送日报">
        <SendMsgPopup :Phone="phone" @handle_close="isSendMsgDialogVisible=false"></SendMsgPopup>
    </el-dialog>
  </div>
</template>

<script>

import SendMsgPopup from './SendMsgPopup';
import MyApis from "../../../apis";
export default {
  name: "TourReportManagerView",
  controller: "UI",
  action: "TourReportManagerView",
  components: {
    SendMsgPopup
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      ReportTime:  [new Date(), new Date()],
      ReportStationId: "",
      ReportStationArr: [],
      isSendMsgDialogVisible:false
    };
  },
  created: function () {   
     this.search();
  },
  mounted: function () {
     this.getStation();
  },
  methods: {
    getStation(){
      this.config
        .getUValue("System.Report:System.Report.Station", "")
        .then(d => {
          this.ReportStationArr = d.JValue;
        })
        .catch(e => console.error(e));
    },
        errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        BeginDate:new Date(this.ReportTime[0].format("yyyy-MM-dd 00:00")),
        EndDate:new Date(this.ReportTime[1].format("yyyy-MM-dd 23:59")),
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,   
      };
      if(this.ReportStationId&&this.ReportStationId!=""){
        searchInfo.ReportStationId=this.ReportStationId;
      }
      console.log(searchInfo);
      this.loading = true;
      new MyApis.TourReportResourcesApi()
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.ContentList;
          this.total = r.TotalCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/TourReport/UI/TourReportManagerInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/TourReport/ui/TourReportManagerInfo",
        query: { InfoId: row.ID, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/TourReport/ui/TourReportManagerInfo",
        query: { InfoId: row.ID, type: "edit" ,time:new Date()},
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.loadingText = "删除中...";
          new MyApis.TourReportResourcesApi()
            .DelItem(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.loading = false;
              this.search();
            })
            .catch((e) => {
              this.loading = false;
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.ReportTime = [new Date(), new Date()];
      this.ReportStationId = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },    
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd");
    },  
    formatDateTime(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
  },
};
</script>

